import { useMantineTheme } from '@mantine/core';

export function useAgedBalanceColors() {
  const theme = useMantineTheme();

  return {
    notDue: theme.colors.purple[2],
    totalBalance: theme.colors.purple[7],
    netBalance: theme.colors.purple[7],
    0: theme.colors.purple[3],
    30: theme.colors.purple[4],
    60: theme.colors.purple[5],
    90: theme.colors.purple[6],
  } as const;
}
